<template>
<div class="form">
    <div v-show="!loading">
        <h1>{{ $lang("喜迎新春歡樂跑") }}</h1>
        <b-form ref="form1" @submit="onSubmit">
            <div class="form-header">
                <div class="checkbox-group">
                    <p class="checkbox-attention-text">
                        <span><b>{{ $lang('TEXT_ATTENTION_CHECKBOX') }}</b></span></p>
                    <ol class="checkbox-attention">
                        <li>
                            {{ $lang('ATTENTION_ONE') }}(<a :href="url" target="_blank">{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a>)
                            .{{ $lang('CYCLING_ATTENTION_ONE') }}
                        </li>
                        <li>{{ $lang('ATTENTION_THREE') }}</li>
                    </ol>
                    <p class="checkbox-attention-text"><span><b>{{ $lang('TEXT_ACCEPT_CHECKBOX') }}</b></span>
                    </p>
                    <b-form-checkbox v-model="form.isAgree1" :disabled="is_perview">
                        <span class="lbl">{{ $lang('TEXT_ACCEPT_SELF') }}</span>
                    </b-form-checkbox>
                    <InputFile accept=".jpg, .png, .gif, .pdf" v-model="form.healthFile" :word="isAdultCaptain? $lang('上傳其他參加者的聲明書') : $lang('BTN_UPLOAD_FILE')" :disabled="is_perview"/>
                    <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
                </div>
            </div>
            
            <template v-for="item in form.teamMembers">
                <tower-form :requiredType="requiredType" :key="item.key" :value="item" :rules="rules" class="dashed" ref="form-item" :disabled="is_perview">
                    <template v-if="form.teamMembers.length > 1" v-slot:remove>
                        <b-form-group horizontal>
                            <label slot="label"></label>
                            <b-btn variant="info" size="sm" class="del" @click.prevent="handleRemove(item)"><i class="fa fa-trash-o" style="margin-right:5px"></i>{{ $lang("刪除") }}</b-btn>
                        </b-form-group>
                    </template>
                </tower-form>
            </template>

            <div class="form-footer">
                <div>
                    <template v-if="!is_perview">
                        <b-btn v-if="form.teamMembers.length < 4" variant="success btn-round" @click.prevent="handleAdd">+{{ $lang("添加參賽者") }}</b-btn>
                        <button type="submit" class="btn btn-primary btn-submit save" @click="save" :disabled="isDisable">
                            {{ $lang("TEXT_SAVE") }}
                        </button>
                        <button type="submit" class="btn btn-primary btn-submit save" @click="submitForm" :disabled="isDisable">{{ $lang("提交") }}
                        </button>
                    </template>
                    <p>
                        {{ $lang("TITLE_FORM_TIP") }}
                    </p>
                </div>
            </div>
        </b-form>
    </div>
    <div class="spinner" v-show="loading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
</div>
</template>

<script>
import {
    $apis
} from "@/helper";
import TowerForm from "@/components/TowerForm";
import InputFile from "@/components/InputFile";
import {
    ValidationObserver
} from "vee-validate";
import utils from "@/helper/utils";

export default {
    props: {
        mode: {
            type: String,
            default: "new"
        }
    },
    components: {
        InputFile,
        TowerForm,
        ValidationObserver
    },
    data() {
        return {
            loading: false,
            index: 4,
            requiredType: false,
            status: '',
            isDisable: false,
            // selected: "individual",
            isIdentity: true,
            // participateDate: [],
            rules: {
                birth: {
                    tower_race_age: [1900, 2006]
                }
                // phone: {
                //     mobile: ''
                // }
            },
            form: {
                id: null,
                healthFile: "",
                isAgree1: "",
                teamMembers: [{
                        name: "",
                        bornAt: "",
                        gender: "M",
                        phone: "",
                        idType: "",
                        idNumber: "",
                        // email: ""
                    }]
            },
        };
    },
    methods: {
        save() {
            this.requiredType = false;
            this.status = 'draft';
            // console.log(this.form2.mixedChallenge.length);
        },
        submitForm() {
            this.requiredType = true;
            this.status = 'approval';
        },
        async onSubmit(evt) {
            evt.preventDefault();
            var form = {
                ...this.form,
                status: this.status,
                teamMembers: this.uploadMembers(this.form.teamMembers)
            };
            if (this.status === 'draft') {
                this.recordUpdate(form);
                this.errorScoll();
            }else {
                // var haveChild = this.haveChild(form);
                // if(haveChild) {
                //     var haveAdult = this.haveAdult(form);
                //     if(!haveAdult) {
                //         this.notification.warning(this.$lang("報名者不足15歲的需有至少一位成年人陪同"));
                //         return false;
                //     }
                // }
                var promise_list = await this.$refs["form-item"].map(item =>
                    item.onSubmit()
                );
                // var result = promise_list.every(item => item);
                // await this.$validator.validateAll("form1");
                // this.errorScoll();
                var needHealthFile = this.needHealthFile(form);
                this.$validator.validateAll("form1").then(validate => {
                Promise.all(promise_list).then(list => {
                    var result = list.every(item => item);
                    this.errorScoll();

                    if (!needHealthFile) {
                        if (form.isAgree1) {
                            if(result) {
                                this.recordUpdate(form);
                                this.errorScoll();
                            }
                        }else {
                            this.notification.warning(this.$lang("TEXT_WARNING_3"));
                        }
                    } else {
                        if (form.isAgree1) {
                            if (form.healthFile) {
                                if(result) {
                                    this.recordUpdate(form);
                                    this.errorScoll();
                                }
                            }else {
                                this.notification.warning(this.$lang("TEXT_WARNING_1"));
                            }
                        }else {
                            this.notification.warning(this.$lang("TEXT_WARNING_3"));
                        }
                    }

                // 不用判斷child
                // if (form.isAgree1 && form.healthFile) {
                //     if(result) {
                //         this.recordUpdate(form);
                //         this.errorScoll();
                //     }
                // }else {
                //     this.notification.warning(this.$lang("TEXT_WARNING_1"));
                // }
            })
                });
            }
        },
        // 防止連續點擊重複提交
        PreventDuplicateSubmit() {
            this.isDisable=true
            setTimeout(()=>{
                this.isDisable=false;  //点击一次时隔两秒后才能再次点击
            },2000);
        },
        errorScoll() {
            let errEle = document.querySelector(".is-invalid");
            errEle ? this.animateScroll(errEle, 50) : "";
        },
        animateScroll(element, speed) {
            //获取元素相对窗口的top值，此处应加上窗口本身的偏移
            let top = window.pageYOffset + element.getBoundingClientRect().top;
            // 获取当前距离窗口的top值
            let osTop = document.documentElement.scrollTop || document.body.srcollTop;
            let requestId;
            let currentNumber = 0;
            //采用requestAnimationFrame，平滑动画
            function step() {
                if (osTop >= top) {
                    currentNumber = osTop -= speed;
                    window.scrollTo(0, osTop);
                    requestId = window.requestAnimationFrame(step);
                } else {
                    window.cancelAnimationFrame(requestId);
                }
            }
            window.requestAnimationFrame(step);
        },
        haveChild(form) {
            let haveChild = false;
            let teamMembers = form.teamMembers;
            teamMembers.forEach((item, index) => {
                const bornAt = item.bornAt;
                const year = utils.getYear(bornAt);
                if (year > 2006 && year <= 2009) {
                    haveChild = true;
                }
            });
            return haveChild;
        },
        haveAdult(form) {
            let haveAdult = false;
            let teamMembers = form.teamMembers;
            teamMembers.forEach((item, index) => {
                const bornAt = item.bornAt;
                const year = utils.getYear(bornAt);
                if (year <= 2003 && year >= 1951) {
                    haveAdult = true;
                }
            });
            return haveAdult;
        },
        needHealthFile(form) {
            let needHealthFile = false;
            let teamMembers = form.teamMembers;
            teamMembers.forEach((item, index) => {
                const bornAt = item.bornAt;
                const year = utils.getYear(bornAt);
                if (year > 2003 && year <= 2006) {
                    needHealthFile = true;
                }
            });
            return needHealthFile;
        },
        handleRemove(item) {
            if (this.form.teamMembers.length <= 1) {
                return;
            }
            var index = this.form.teamMembers.indexOf(item);
            if (index !== -1) {
                this.form.teamMembers.splice(index, 1);
            }
        },
        handleAdd() {
            this.index++;
            this.form.teamMembers.push({
                index: this.index,
                name: null,
                gender: null,
                bornAt: "",
                phone: "",
                idType: "",
                idNumber: "",
                // participateDate: [],
                // isNeedCar: ""
            });
        },
        uploadMembers(list) {
            return list.map((item, index) => {
                delete item["key"];
                delete item["index"];
                item.bornAt = this.$getYear(item.bornAt) || "";
                return item;
            });
        },
        recordUpdate(form) {
            if(this.status == 'draft') {
                this.saveForm(form)
                .then(resp => {
                    let type = this.mode;
                    if (type == "edit") {
                        this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
                    } else {
                        this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
                    }
                    this.$router.push({
                        name: "tower-race"
                    });
                })
                .catch(err => {
                    if (err.data.teamMembers instanceof Array) {
                        err.data.teamMembers.forEach((item, index) => {
                            this.$refs["form-item"][index].validateErrors(
                                item.path,
                                this.$lang(item.message)
                            );
                            this.notification.error(this.$lang(item.message));
                        });
                    } else {
                        if (err.data.length == 0) {
                            this.notification.error(this.$lang(err.message));
                        }
                        var errs = err.data.teamMembers;
                        var that = this;
                        Object.keys(errs).forEach(function (key) {
                            that.notification.error(that.$lang(errs[key].message));
                        });
                    }
                })
                .finally(() => {
                    this.errorScoll();
                });
            }else {
                this.recordPro(form)
                .then(resp => {
                    // let type = this.mode;
                    // if (type == "edit") {
                    //     this.notification.success(this.$lang("提交成功"));
                    // } else {
                    //     this.notification.success(this.$lang("提交成功"));
                    // }
                    this.notification.success(this.$lang("提交成功"));
                    this.$router.push({
                        name: "tower-race"
                    });
                })
                .catch(err => {
                    if (err.data.teamMembers instanceof Array) {
                        err.data.teamMembers.forEach((item, index) => {
                            this.$refs["form-item"][index].validateErrors(
                                item.path,
                                this.$lang(item.message)
                            );
                            this.notification.error(this.$lang(item.message));
                        });
                    } else {
                        if (err.data.length == 0) {
                            this.notification.error(this.$lang(err.message));
                        }
                        var teamMembers = err.data.teamMembers;
                        var that = this;
                        Object.keys(teamMembers).forEach(function (key) {
                            that.$refs["form-item"][key].validateErrors(
                                teamMembers[key].path,
                                that.$lang(teamMembers[key].message)
                            );
                            that.notification.error(that.$lang(teamMembers[key].message));
                        });
                        // var errs = err.data.teamMembers;
                        // var that = this;
                        // Object.keys(errs).forEach(function (key) {
                        //     that.notification.error(that.$lang(errs[key].message));
                        // });
                    }
                })
                .finally(() => {
                    this.errorScoll();
                });
            }
        },
        async recordPro(form) {
            this.PreventDuplicateSubmit();
            return new Promise((resolve, reject) => {
                $apis.towerRace
                    .recordUpdate(form)
                    .then(resp => {
                        if (resp.code === 0) {
                            resolve(resp);
                        } else {
                            reject(resp);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        // save
        async saveForm(form) {
            this.PreventDuplicateSubmit();
            return new Promise((resolve, reject) => {
                $apis.towerRace
                    .save(form)
                    .then(resp => {
                        if (resp.code === 0) {
                            resolve(resp);
                        } else {
                            reject(resp);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            });
        },
        async recordDetail(id) {
            if(this.mode === 'perview') {
                this.loading = true;
            let resp = await $apis.towerRace.recordDetail({
                id
            });
            this.loading = false;
            this.form = resp.data;
            }else {
            this.loading = true;
            let resp = await $apis.towerRace.load({id});
            this.loading = false;
            this.form = resp.data;
            }
        },
        getUserInfo() {
            this.loading = true;
            $apis.user
                .getUserInfo()
                .then(resp => {
                    var data = resp.data;
                        this.form.teamMembers[0].name = data.firstNameZh + data.lastNameZh || data.FirstnamePt + data.LastnamePt,
                        this.form.teamMembers[0].bornAt = data.bornAt
                        this.form.teamMembers[0].gender = data.gender
                        this.form.teamMembers[0].idType = data.idType
                        this.form.teamMembers[0].idNumber = data.idNumber
                        this.form.teamMembers[0].phone = ''
                        // this.form.teamMembers[0].email = ''
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        disabled() {
            return this.mode === "perview" || this.mode === "edit";
        },
        is_perview() {
            return this.mode === "perview";
        },
        is_edit() {
            return this.mode === "edit";
        },
        is_new() {
            return this.mode === "new";
        },
        downPdf() {
            return this.$store.getters["base/springFestivalCycleHealthFileExample"];
        },
        link() {
            return this.$store.getters["base/baseUrl"];
        },
        url() {
            return this.link + this.downPdf;
        },
        isAdultCaptain() {
            var value = this.form.teamMembers[0].bornAt;
            if (!value) return false;
            var year = new Date(value).getFullYear();
            let result = year >= 1900 && year <= 2003;
            // if (!result) {
            //     this.form.isAgree1 = null;
            // }
            return result;
        }
    },
    created() {
        var id = this.$route.params.slug;
        var isNew = this.is_new;
        this.form.id = id;
        id && this.recordDetail(id);
        isNew && this.getUserInfo();
    }
};
</script>
